import { render, staticRenderFns } from "./RmpLink.vue?vue&type=template&id=1fd8ea88"
import script from "./RmpLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./RmpLink.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports